/**
 * Envoltorio de pantalla.
 *
 * Garantiza que TODA pantalla tiene un `<h1>` con el nombre de la sección,
 * aunque no sea visible: sin él, la navegación por encabezados de un lector de
 * pantalla no tiene ningún punto de entrada.
 */

import type { ReactNode } from 'react';
import estilos from './Pantalla.module.css';

interface Props {
  titulo: string;
  /** Si el título también se ve, además de anunciarse. */
  tituloVisible?: boolean;
  children: ReactNode;
}

export function Pantalla({ titulo, tituloVisible = false, children }: Props) {
  return (
    <section className={estilos.pantalla}>
      <h1 className={tituloVisible ? estilos.titulo : 'sr-only'}>{titulo}</h1>
      {children}
    </section>
  );
}
